import { themeA } from './themes/themeA'
import { themeB } from './themes/themeB'
import { themeC } from './themes/themeC'
import { themeD } from './themes/themeD'
import { themeE } from './themes/themeE'
import { themeF } from './themes/themeF'
import { themeG } from './themes/themeG'
import { themeH } from './themes/themeH'

export const themes = { themeA, themeB, themeC, themeD, themeE, themeF, themeG, themeH }
export const defaultThemeKey = 'themeB'
export const theme = themeB
